import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=faf06796"
import script from "./newsList.ts?vue&type=script&lang=js&external"
export * from "./newsList.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports